import React from 'react';
import axios from 'axios';

import Dashboard from './screens/Dashboard';
import LoginScreen from './screens/LoginScreen';
import { loadProjectList, loadClientList, loadUserDirectory, loadSettings } from './lib/fetchData';

export default () => {
	const [isLoggedIn, setIsLoggedIn] = React.useState(localStorage.getItem('isLoggedIn') === 'true');
	const [isLoading, setIsLoading] = React.useState(true);
	const [isReady, setIsReady] = React.useState(false);

	const fetchData = async () => {
		await loadProjectList();
		await loadClientList();
		await loadUserDirectory();
		await loadSettings();
	};

	React.useEffect(() => {
		axios
			.get('/jwt/token?_format=json')
			.then(async () => await fetchData())
			.then(() => {
				if (!isLoggedIn) {
					localStorage.setItem('isLoggedIn', true);
					setIsLoggedIn(true);
				}
			})
			.catch(error => {
				console.error(error);

				if (isLoggedIn) {
					localStorage.setItem('isLoggedIn', false);
					setIsLoggedIn(false);
				}
			});
	}, []);

	React.useEffect(() => {
		if (isLoggedIn) {
			fetchData().then(() => {
				setIsReady(true);
				setIsLoading(false);
			});
		} else {
			setIsLoading(false);
		}
	}, [isLoggedIn]);

	return (
		<>
			{isReady ? (
				<Dashboard navWidth={630} />
			) : isLoading ? (
				<h1>Loading...</h1>
			) : isLoggedIn ? (
				<h1>Failed to load project list</h1>
			) : (
				<LoginScreen />
			)}
		</>
	);
};
